import AdvancedMap from '../../local_modules/advanced_map'

import {
    ROOM_CLIENT_LIST,
    ROOM_CLIENT_LOGIN,
    ROOM_CLIENT_UPDATE,
    ROOM_CLIENT_LOGOUT, getUserSorting,
//    userSortCallbackFollowees,
//    userSortCallbackWatching
} from '../constants/users'

import {
    ROOM_LEAVED
} from '../constants/rooms';

export default function users(state = new AdvancedMap(), action, fullState) {

    if (action.type === ROOM_CLIENT_LIST) {
        let ret = new AdvancedMap(state);

        for (let index in action.list) {
            let user = action.list[index];
            ret.set({ufrag: user.ufrag, nick: user.nick, uid: user.uid}, user);
        }

        return ret;
    }

    if (action.type === ROOM_CLIENT_LOGIN) {
        let ret = new AdvancedMap(state);
        ret.set({ufrag: action.user.ufrag, nick: action.user.nick, uid: action.user.uid}, action.user);

        return ret;
    }

    if (action.type === ROOM_CLIENT_UPDATE) {
        let ret = new AdvancedMap(state);
        ret.set({ufrag: action.user.ufrag, nick: action.user.nick, uid: action.user.uid}, action.user);

        return ret;
    }

    if (action.type === ROOM_CLIENT_LOGOUT) {
        let remove = true;
        for (let roomid in fullState.rooms) {
            if (roomid === action.roomid) continue;
            
            let user = fullState.rooms[roomid].users.get({ufrag: action.user.ufrag});
            if (user) {
                remove = false;
                return state;
            }
        }

        if (remove) {
            let ret = new AdvancedMap(state);
            let user = state.get({ufrag: action.user.ufrag});
            user.online = false;
            ret.set({ufrag: action.user.ufrag, nick: action.user.nick, uid: action.user.uid}, user);
           // ret.delete({ufrag: action.user.ufrag});

            return ret;
        }
    }

    if (action.type === ROOM_LEAVED) {

        // Just rebuild all users list
        var ret = new AdvancedMap();
        for (let roomid in fullState.rooms) {
            if (roomid === action.roomid) continue;

            let room = fullState.rooms[roomid];
            room.users.forEach(function(value, key) {
                ret.set(key, value)
            })
        }

        return ret;
    }

    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/users.js